<template>
	<div class="container">
		<!--页面开始-->
		<div class="main_box">
			<div class="tab_box">
				<van-tabs
					v-model="nowIndex"
					color="#7494F6"
					title-active-color="#7494F6"
					swipeable
					line-width="1.6rem"
					@click="tabClick"
				>
					<van-tab title="本人信息">
						<!--本人信息-->
						<userMsg
							type="1"
							ref="childUser"
							@initBtn="initBtn"
							@initBtn2="initBtn2"
							@botHide="botHide"
							@botShow="botShow"
						></userMsg>
						<!--本人信息-->
						<div v-show="isTabbar" class="bottom_btn">
							<van-button
								type="info"
								block
								@click="onSubmit"
								color="#4f56fe"
							>
								保存
							</van-button>
						</div>
					</van-tab>
					<van-tab title="他人信息">
						<div class="list_box">
							<div class="user_list">
								<div v-for="(value, index) in listData" class="list_el" @click="goEdit(value)">
									<!-- <div class="one">
										<img src="../../assets/img/icon_nocheck.png" />
									</div> -->
									<div class="two">{{ value.username }}</div>
									<div class="three">{{ initCard(value) }}</div>
									<div class="four">
										<van-icon name="arrow" />
									</div>
								</div>
							</div>
							<div v-if="isShow" class="btn_add">
								<img src="../../assets/img/icon_add.png" @click="goAdd" />
							</div>
						</div>
					</van-tab>
				</van-tabs>
			</div>
		</div>
		<!--页面开始-->
	</div>
</template>

<script>
//import { getInfo, saveMsg, cardType } from "@/api/public";
import { otherList } from "@/api/other/index";
import userMsg from '@/components/userMsg'
import { shareUrl } from '@/utils/wxshare'

export default {
	components:{
		userMsg,
	},
	data() {
		return {
			listData: [],
			nowIndex: Number(sessionStorage.getItem('tabIndex')) || 0,
			isShow: true,
			isTabbar: false, //判断页面的fixed内容是展示还是隐藏
		}
	},
	created(){
		let that = this;
		if(!localStorage.getItem('token')) {
			this.$router.push({path:'/login'});
		}
		//获取成员列表
		otherList().then(res => {
			that.listData = res.data;
			if(that.listData.length >= 8) {
				that.isShow = false;
			}
		});
	},
	mounted() {
		//微信分享
		let that = this;
		that.$nextTick(() => {
			setTimeout(() => {
				that.isTabbar = true;
			}, 30);
			shareUrl(that);
		});
	},
	watch: {
		//
	},
	methods: {
		botHide() {
			this.isTabbar = false;
		},
		botShow() {
			this.isTabbar = true;
		},
		initBtn2() {
			
		},
		//刷新页面
		initBtn() {
			//window.location.reload();
		},
		//初始化身份证号
		initCard(value) {
			let that = this;
			if(value.card_type == 2) {
				//军官证
				let str1 = value.card_number.slice(0, 3);
				let str2 = value.card_number.slice(-1);
				return str1 + '***********' + str2;
			}else {
				let str1 = value.card_number.slice(0, 3);
				let str2 = value.card_number.slice(-4);
				return str1 + '***********' + str2;
			}
		},
		//点击Tab
		tabClick(name, title) {
			sessionStorage.setItem('tabIndex', name);
		},
		//点击保存
		onSubmit() {
			let that = this;
			that.$refs.childUser.onSubmit();
		},
		//点击添加
		goAdd() {
			let that = this;
			that.$router.push({path: '/otheraddedit', query: {type: 1}});
		},
		//点击编辑
		goEdit(value) {
			let that = this;
			that.$router.push({path: '/otheraddedit', query: {type: 2, value: value.id}});
		},
	},
	beforeDestroy() {
		//
	}
}
</script>
</script>

<style scoped>
.tab_box{
	padding: 0.4rem 0.2rem;
}

.bottom_btn{
	/* position: fixed; */
	margin-top: 4rem;
	width: 100%;
	left: 0;
	padding: 1.2rem 1rem;
	bottom: 0;
}

.list_box{
	padding-top: 0.5rem;
}
/*列表*/
.list_el{
	height: 1.5rem;
	display: flex;
	align-items: center;
	border-bottom: 1px solid #F7F7F7;
}
.list_el .one img, .list_el .four img{
	width: 0.32rem;
}
.list_el .one{
	width: 1.4rem;
	position: relative;
	top: 0.14rem;
	text-align: center;
}
.list_el .two{
	width: 3rem;
	color: #333333;
	text-align: center;
	font-size: 0.427rem;
	white-space:nowrap; 
	overflow:hidden; 
	text-overflow:ellipsis;
}
.list_el .three{
	flex: 1;
	position: relative;
	top: 1px;
	color: #999999;
	font-size: 0.427rem;
}
.list_el .four{
	width: 1.5rem;
	position: relative;
	top: 0rem;
}

.btn_add{
	padding-top: 0.2rem;
	width: 80%;
	margin: 0 auto;
}
.btn_add img{
	width: 100%;
}
.van-button{
	height: 1.2rem;
}
</style>
